import { render, staticRenderFns } from "./ItemTagPicker.vue?vue&type=template&id=4e488d58&"
import script from "./ItemTagPicker.vue?vue&type=script&lang=ts&"
export * from "./ItemTagPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports